import React from 'react'
import { connect } from 'react-redux'

import LineChart from '~/components/charts/line-chart'
import Panel from '~/components/Panel'

const HistoryChart = ({ loading, data = {} }) => (
  <Panel noPaddingBody title="Histórico" isLoading={loading}>
    <LineChart data={data.orderIncomeByDay} loading={loading} />
  </Panel>
)

export default connect(store => ({
  theme: store.theme.currentTheme
}))(HistoryChart)
